import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem('cbm_cookies_accepted');
    if (!accepted) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem('cbm_cookies_accepted', 'accepted');
    setVisible(false);
  };

  const reject = () => {
    localStorage.setItem('cbm_cookies_accepted', 'rejected');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div data-testid="cookie-banner" className="fixed bottom-0 left-0 right-0 z-[100] bg-slate-900 text-white p-4 md:p-5 shadow-2xl">
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <div className="flex-1">
          <p className="text-sm leading-relaxed">
            Questo sito utilizza <strong>cookie tecnici</strong> necessari al funzionamento (es. carrello). 
            Non utilizziamo cookie di profilazione. Per maggiori informazioni consulta la nostra{' '}
            <Link to="/privacy" className="text-[#FFCA28] underline hover:text-white">Privacy Policy</Link> e la nostra{' '}
            <Link to="/cookie-policy" className="text-[#FFCA28] underline hover:text-white">Cookie Policy</Link>.
          </p>
        </div>
        <div className="flex items-center gap-3 shrink-0">
          <button
            onClick={reject}
            data-testid="cookie-reject-btn"
            className="px-5 py-2.5 bg-transparent border border-slate-600 text-slate-300 font-heading font-bold text-sm rounded-full hover:bg-slate-800 transition-colors"
          >
            Rifiuta
          </button>
          <button
            onClick={accept}
            data-testid="cookie-accept-btn"
            className="px-6 py-2.5 bg-[#FF7043] text-white font-heading font-bold text-sm rounded-full hover:bg-[#e65100] transition-colors"
          >
            Accetta
          </button>
        </div>
      </div>
    </div>
  );
}
